<template>
  <div class="pa-8" v-if="event">
    <v-card class="mx-3 mt-8 pb-0">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title style="justify-content: center">{{ $t('EVENTFORM.title') }}</v-toolbar-title>
      </v-toolbar>
      <v-row class="pa-0 px-3">
        <v-col cols="12" class="pa-0 view-tab-col" xl="3" lg="2" md="3" sm="4">
          <v-tabs class="view-tab-horizontal" v-model="viewTab">
            <v-tab id="editevent-event-tab">
              <v-icon left> {{ mdiCalendar }} </v-icon>
              {{ $t('EVENTFORM.tabs.event') }}
            </v-tab>
            <v-tab v-if="!newEvent" id="editevent-ptcpt-tab">
              <v-icon left> {{ mdiAccountGroup }} </v-icon>
              {{ $t('EVENTFORM.tabs.participants.title') }}
            </v-tab>
            <v-tab v-if="!newEvent && event.type == 'minicourse'" id="editevent-cert-tab">
              <v-icon left> {{ mdiTextBox }} </v-icon>
              {{ $t('TOOLBAR.items.certificates') }}
            </v-tab>
          </v-tabs>
          
          <v-tabs class="view-tab-vertical" v-model="viewTab" vertical left>
            <v-tab id="editevent-event-tab">
              <v-icon left> {{ mdiCalendar }} </v-icon>
              {{ $t('EVENTFORM.tabs.event') }}
            </v-tab>
            <v-tab v-if="!newEvent" id="editevent-ptcpt-tab">
              <v-icon left> {{ mdiAccountGroup }} </v-icon>
              {{ $t('EVENTFORM.tabs.participants.title') }}
            </v-tab>
            <v-tab v-if="!newEvent && event.type == 'minicourse'" id="editevent-cert-tab">
              <v-icon left> {{ mdiTextBox }} </v-icon>
              {{ $t('TOOLBAR.items.certificates') }}
            </v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="12" class="py-0 px-0" xl="9" lg="10" md="9" sm="8">
          <v-tabs-items v-model="viewTab">
            <v-tab-item>
              <v-card flat>
                <v-tabs v-model="tab">
                  <v-tab id="editevent-en-tab">English</v-tab>
                  <v-tab id="editevent-pt-tab">Português</v-tab>
                  <v-tab id="editevent-es-tab">Español</v-tab>
                </v-tabs>
                <v-divider></v-divider>

              <!---START FORM---->

                <!-- <v-col class="pa-10"> -->
                <v-card flat class="pt-5 px-5">
                  <v-form ref="eventcontentform">
                    <v-tabs-items v-model="tab">
                      <v-tab-item v-for="lang in langs" :key="lang">
                        <edit-event-content
                          :lang="`${lang}`"
                          :content="
                            event.content != undefined ? event.content[`${lang}`] : {}
                          "
                        />
                      </v-tab-item>
                    </v-tabs-items>

                    <v-text-field
                      id="edit-event-location-input"
                      v-model="eventLocation"
                      required
                      outlined
                      :label="$t('EVENTFORM.form.location')"
                      :rules="[(v) => !!v || $t('EVENTFORM.form_validation.location')]"
                      :prepend-inner-icon="mdiMapMarker"
                    ></v-text-field>
                  </v-form>
                  <v-form ref="eventform" class="pb-10">
                    <event-edit-schedule :schedule="event.schedule" />

                    <v-file-input
                      id="edit-event-image-input"
                      :label="$t('EVENTFORM.form.image')"
                      outlined
                      v-model="imageFile"
                    ></v-file-input>

                    <v-text-field
                      id="edit-event-video-input"
                      :label="$t('EVENTFORM.form.video_url')"
                      outlined
                      :prepend-inner-icon="mdiVideo"
                      v-model="event.medias.video"
                    ></v-text-field>

                    <v-select
                      v-model="event.type"
                      :items="types"
                      item-text="name"
                      item-value="type"
                      :label="$t('EVENTFORM.form.types')"
                      outlined
                    ></v-select>

                    <event-edit-speakers
                      v-if="event.type !== 'food'"
                      :speakers="event.speakers"
                      v-on:input="updateSpeakers($event)"
                    />

                    <event-edit-style :eventStyle="event.style" />
                  </v-form>
                </v-card>
                <!-- </v-col> -->
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <event-participant-list
                :participants="event.participants"
                @sendEmail="sendEmail($event)"
              ></event-participant-list>
            </v-tab-item>
            <v-tab-item v-if="event.type == 'minicourse'">
              <event-certificate
                :eventName="event.content.pt.title"
                :participants="event.participants"
              ></event-certificate>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="editevent-save-button"
          v-on="on"
          @click="saveEvent()"
          color="#FBBD21"
          dark
          fab
          fixed
          bottom
          right
        >
          <v-icon>{{ mdiContentSave }}</v-icon>
        </v-btn>
      </template>

      <span>{{ $t('EVENTFORM.form.save') }}</span>
    </v-tooltip>

    <v-dialog v-model="requiredModal" max-width="400px">
        <v-card width="100%" color="red">
          <v-card-title style="color: white;">
            <v-icon color="white" class="mr-2">{{ mdiAlertCircleOutline }}</v-icon>
            {{ $t('EVENTFORM.form_validation.warning_modal.title') }}
          </v-card-title>
          <v-card-text style="color: white;">
            {{ $t('EVENTFORM.form_validation.warning_modal.warning') }}
          </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="emailDialog" max-width="500px" persistent>
      <email-form
        :toMany="!selectedUser"
        :to="selectedUser ? selectedUser.email : null"
        :receivers="!selectedUser ? event.participants : null"
        :event="event"
        @close="selectedUser = null; emailDialog = false"
      />
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      top
      right
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.show = false">
          {{ $t("PROFILE.closeButton") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiCalendar, mdiAccountGroup, mdiMapMarker, mdiContentSave, mdiVideo, mdiAlertCircleOutline, mdiTextBox } from "@mdi/js";
import EditEventContent from "@/components/molecules/events/[EVENT]EditMainContent.vue";
import EventEditSchedule from "@/components/molecules/events/[EVENT]EditSchedule.vue";
import EventEditSpeakers from "@/components/molecules/events/[EVENT]EditSpeakers.vue";
import EventEditStyle from "@/components/molecules/events/[EVENT]EditStyle.vue";
import EventParticipantList from "@/components/molecules/events/[EVENT]ParticipantList.vue";
import EventCertificate from "@/components/molecules/events/[EVENT]Certificate.vue";
import EmailForm from "@/components/atoms/EmailForm.vue";

export default {
  components: {
    EditEventContent,
    EventEditSchedule,
    EventEditSpeakers,
    EventEditStyle,
    EventParticipantList,
    EmailForm,
    EventCertificate
  },
  data() {
    return {
      tab: 0,
      viewTab: 0,
      event: null,
      eventLocation: '',
      newEvent: false,
      valid: false,
      mdiContentSave,
      mdiCalendar,
      mdiMapMarker,
      mdiAccountGroup,
      mdiVideo,
      mdiAlertCircleOutline,
      langs: ["en", "pt", "es"],
      imageFile: null,
      requiredModal: false,
      modalTimeout: null,
      emailDialog: false,
      selectedUser: null,
      mdiTextBox,
    };
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    types() {
      const translatedTypes = [];
      const types = [
        "session",
        "minicourse",
        "food",
        "speak",
        "round_table",
        "meeting",
        "opening",
        "other",
      ];

      types.forEach((element) =>
        translatedTypes.push({type: element, name: this.$t(`EVENTFORM.types['${element}']`)})
      );

      return translatedTypes;
    },
  },
  methods: {
    updateSpeakers(value) {
      this.event.speakers = value;
    },
    transformVideoUrl(url) {
      if (url.includes('/watch?v=')) {
        const parts = url.split('/watch?v=');
        return `${parts[0]}/embed/${parts[1].split('&')[0]}`;
      }
      
      return url;
    },
    async createEvent() {
      this.event.medias.video = this.transformVideoUrl(this.event.medias.video || '');

      if (this.event.type === 'food') this.event.speakers = [];

      if (this.imageFile) this.event.medias.image = true;

      let created = await this.$store.dispatch("createTalk", this.event);

      if (created) {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: this.$t('EVENTFORM.create_success'),
          color: "success",
        });

        if (this.imageFile)
          this.$store.dispatch("uploadEventImage", {
            file: this.imageFile,
            name: created.id,
          });
      } else {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: this.$t('EVENTFORM.create_error'),
          color: "error",
        });
      }
    },
    async updateEvent() {
      this.event.medias.video = this.transformVideoUrl(this.event.medias.video || '');

      if (this.event.type === 'food') this.event.speakers = [];

      if (this.imageFile) this.event.medias.image = true;

      const updated = await this.$store.dispatch("updateTalk", {
        id: this.$route.params.eventId,
        data: this.event,
      });

      if (updated) {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: this.$t('EVENTFORM.update_success'),
          color: "success",
        });

        if (this.event.participants) {
          this.event.participants.forEach(p => {
            this.$store.dispatch('updateUserPresence', {
              userId: p.id,
              presence: p.presence,
              eventId: this.$route.params.eventId
            });
          });
        }

        if (this.imageFile)
          this.$store.dispatch("uploadEventImage", {
            file: this.imageFile,
            name: this.$route.params.eventId,
          });
      } else {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: this.$t('EVENTFORM.update_error'),
          color: "error",
        });
      }
    },
    async saveEvent() {
      if (
        this.$refs.eventcontentform.validate() &&
        this.$refs.eventform.validate()
      ) {
        for (let locale in this.event.content) {
          this.event.content[locale].location = this.eventLocation;
        }

        this.newEvent ? await this.createEvent() : await this.updateEvent();

        await this.$store.dispatch("getTalks");
        this.$router.push("/dashboard/program");
      } else {
        this.requiredModal = true;
      }
    },
    sendEmail(user) {
      this.selectedUser = user
      this.emailDialog = true;
    }
  },
  async created() {
    var eventId = this.$route.params.eventId;
    if (eventId) {
      this.newEvent = false;
      this.event = await this.$store.dispatch("getTalkById", eventId);
      this.eventLocation = this.event.content['en'].location;
    } else {
      this.newEvent = true;
      this.event = {
        medias: {
          image: false,
          video: "",
        },
        style: {
          mainColor: "#FFFE00",
          icon: mdiCalendar,
        },
        schedule: {
          day: "",
          start: "",
          end: "",
        },
        speakers: [],
        content: {
          ["en"]: {
            title: "",
            description: "",
            location: "",
          },
          ["es"]: {
            title: "",
            description: "",
            location: "",
          },
          ["pt"]: {
            title: "",
            description: "",
            location: "",
          },
        },
      };
    }
  },
  watch: {
    requiredModal(value) {
      if (value) {
        this.modalTimeout = setTimeout(() => {
          this.requiredModal = false;
        }, 3000);
      } else {
        if (this.modalTimeout) {
          clearTimeout(this.modalTimeout);
        }
      }
    }
  }
};
</script>

<style scoped>
  .view-tab-horizontal {
    display: none;
  }

  .view-tab-vertical {
    display: initial;
  }

  .view-tab-vertical #editevent-event-tab,
  .view-tab-vertical #editevent-ptcpt-tab,
  .view-tab-vertical #editevent-cert-tab {
    justify-content: flex-start;
    background-color: #f5f5f5;
  }

  .v-tab {
    width: 100% !important;
  }

  .view-tab-col {
    background-color: #f5f5f5;
  }

  @media (max-width: 600px) {
    .view-tab-horizontal {
      display: initial;
    }

    .view-tab-vertical {
      display: none;
    }
  }
</style>